module.exports = __webpack_public_path__ + "static/img/90.58ab035.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/90.png
// module id = FfQy
// module chunks = 1